export class cIOMAPPEDSERVO {
  actualBackwardFlag: number = 0;
  actualPower: number = 0;
  actualValue: number= 0;
  alarmFlag: string= "";
  brandCode: number= 0;
  deviceCreated: boolean = false;
  deviceInUse: string= "";
  enabledFlag: string= "";
  errorCode: number= 0;
  freqValue: number= 0;
  nodePresentFlag: string= "";
  powerActiveFlag: string= "";
  requestRunBackwardFlag: string = "";
  requestValue: number= 0;
  slaveID: number= 0;
}

export interface MappedServoData {
  cIO_MAPPED_SERVO: cIOMAPPEDSERVO[];
}



